import '../interceptors';
import Axios from 'axios';
import { PREFIX } from '../api-prefix';
/**
 * 用户登录API
 */
export const accountApi = {
    /**
     * 获取当前用户信息
     */
    async getUserInfo () {
        return Axios.get('/sysmanager/api/sysUser/getUserInfo');
    },
    /**
     * 登录
     */
    async login (params) {
        return Axios.post(
            PREFIX.memPlatform + '/systemUsers/login',
            params
        ).then(response => {
            return response.data;
        });
    },
    async ssoLogin (params) {
        return Axios.post(
            '/sso/doLogin',
            params
        ).then(response => {
            return response.data;
        });
    },
    async ssoResetPwd (params) {
        return Axios.put(
            '/sysmanager/inner/sysUser/modifyPassword',
            params
        ).then(response => {
            return response.data;
        });
    },
    /**
     * 登出
     */
    async logout () {
        return Axios.get(
            PREFIX.memPlatform + '/systemUsers/logout'
        );
    },
    /**
     * sso登出
     */
    async ssoLogout () {
        return Axios.get('/sso/logout');
    }
};
